// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__27Z5c","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__lb_Fe"};